// Import model
import { SfExternalLink } from '../models/SfExternalLink';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfExternalLink - handles JSON serialization and deserialization with type validation
 */
export class SfExternalLinkSerializer {
  /**
   * Deserializes a JSON string into a SfExternalLink instance
   */
  static deserialize(json: string): SfExternalLink {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfExternalLink instance
   */
  static fromObject(obj: any): SfExternalLink {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfExternalLink');
    }


    const instance: SfExternalLink = {
      externalId: obj['externalId'] as string | undefined,
      isDeleted: obj['IsDeleted'] as boolean | undefined,
      number_: obj['number'] as string | undefined,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string | undefined,
      floorplanExternalId: obj['floorplanExternalId'] as string | undefined,
      floorplanExternalIdName: obj['floorplanExternalId|Name'] as string | undefined,
      roomExternalId: obj['roomExternalId'] as string | undefined,
      roomExternalIdName: obj['roomExternalId|Name'] as string | undefined,
      relatedObjectType: obj['relatedObjectType'] as string | undefined,
      type_: obj['type'] as string | undefined,
      url: obj['url'] as string | undefined,
      projectExternalId: obj['projectExternalId'] as string | undefined,
      projectExternalIdName: obj['projectExternalId|Name'] as string | undefined,
      proposalExternalId: obj['proposalExternalId'] as string | undefined,
      proposalExternalIdName: obj['proposalExternalId|Name'] as string | undefined,
      isVideo: obj['isVideo'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfExternalLink instances
   */
  static deserializeArray(json: string): SfExternalLink[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfExternalLink instance to a JSON string
   */
  static serialize(instance: SfExternalLink): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfExternalLink instance to a plain object
   */
  static toObject(instance: SfExternalLink): any {
    return {
      'externalId': instance.externalId,
      'IsDeleted': instance.isDeleted,
      'number': instance.number_,
      'description': instance.description,
      'name': instance.name,
      'floorplanExternalId': instance.floorplanExternalId,
      'floorplanExternalId|Name': instance.floorplanExternalIdName,
      'roomExternalId': instance.roomExternalId,
      'roomExternalId|Name': instance.roomExternalIdName,
      'relatedObjectType': instance.relatedObjectType,
      'type': instance.type_,
      'url': instance.url,
      'projectExternalId': instance.projectExternalId,
      'projectExternalId|Name': instance.projectExternalIdName,
      'proposalExternalId': instance.proposalExternalId,
      'proposalExternalId|Name': instance.proposalExternalIdName,
      'isVideo': instance.isVideo,
    };
  }

  /**
   * Serializes an array of SfExternalLink instances to a JSON string
   */
  static serializeArray(instances: SfExternalLink[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
